import axios from "axios";
import {URL_PREFIX} from "../config";

export const getBlogs = (pageId=0, pageNum=10, cancelToken=null) => {
  return axios.get(URL_PREFIX + '/blogs/', {
      cancelToken: cancelToken?.token
  })
}